<script setup lang="ts">
    import type { FriendBuyData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Scripts are initialized for US only in layout
     */
    defineProps<IWidgetProps<FriendBuyData>>();
    const { isUS } = useLocales();
</script>

<template>
    <atm-grid
        full-width
        tag="section"
        v-if="data.code">
        <div class="col-span-2 md:col-span-12">
            <div
                v-show="isUS"
                :id="data.code"
                class="friend-buy-div"></div>
        </div>
    </atm-grid>
</template>
